import React from "react";

// Default structure to initialize form state
export const defaultAccountRows = {
  label: "Number of days of accounts payable",
  current: "",
  previous: "",
};

const AccountsPayableTable = ({ payableData, setPayableData }) => {
  const handleChange = (field, value) => {
    setPayableData({ ...payableData, [field]: value });
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}></th>
            <th style={tableHeaderStyle}>Current Financial Year</th>
            <th style={tableHeaderStyle}>Previous Financial Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                ...tableCellStyle,
                fontWeight: "bold",
                textAlign: "left",
                paddingLeft: "20px",
              }}
            >
              Number of days of accounts payable
            </td>
            <td style={tableCellStyle}>
              <input
                type="number"
                placeholder="Enter number of days"
                value={payableData.current || ""}
                onChange={(e) => handleChange("current", e.target.value)}
                style={inputStyle}
              />
            </td>
            <td style={tableCellStyle}>
              <input
                type="number"
                placeholder="Enter number of days"
                value={payableData.previous || ""}
                onChange={(e) => handleChange("previous", e.target.value)}
                style={inputStyle}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "12px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
};

const tableCellStyle = {
  padding: "12px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default AccountsPayableTable;
